import { useEffect, useState } from "react";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { db } from "../firebase";
import Header from "../components/Header";
import PostCard from "../components/PostCard";

export default function Home() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const q = query(collection(db, "posts"), orderBy("createdAt", "desc"));
        const querySnapshot = await getDocs(q);
        const postsData = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        
        // 고정된 글(isPinned)이 상단에 오도록 정렬
        postsData.sort((a, b) => {
          if (a.isPinned === b.isPinned) return 0;
          return a.isPinned ? -1 : 1;
        });

        console.log("Fetched posts:", postsData); // 디버깅용
        setPosts(postsData);
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
    };

    fetchPosts();
  }, []);

  const formatDate = (timestamp) => {
    if (!timestamp) return "";
    // Firestore Timestamp to Date
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    return `${date.getFullYear()}년 ${date.getMonth() + 1}월 ${date.getDate()}일`;
  };

  return (
    <>
      <Header />
      <main style={{ padding: "32px 16px", maxWidth: "1024px", margin: "0 auto" }}>
        {/* 게시판형 리스트 헤더 */}
        <div style={{ 
          display: "flex", 
          padding: "12px 16px", 
          borderBottom: "2px solid #333", 
          fontWeight: "bold", 
          color: "#495057",
          fontSize: "0.9rem"
        }}>
          <div style={{ flex: 1 }}>제목</div>
          <div style={{ width: "120px" }}>작성자</div>
          <div style={{ width: "100px", textAlign: "center" }}>날짜</div>
          <div style={{ width: "80px", textAlign: "right" }}>좋아요</div>
        </div>

        {/* 리스트 목록 */}
        <div style={{ display: "flex", flexDirection: "column" }}>
          {posts.length === 0 ? (
             <p style={{ textAlign: "center", padding: "48px 0", color: "#868e96" }}>
               게시글이 없습니다. 첫 번째 글을 작성해보세요!
             </p>
          ) : (
            posts.map(post => (
              <PostCard
                key={post.id}
                id={post.id}
                title={post.title}
                author={post.author}
                authorPhoto={post.authorPhoto}
                date={formatDate(post.createdAt)}
                preview={post.content ? (post.content.length > 100 ? post.content.substring(0, 100) + "..." : post.content) : ""}
                likedBy={post.likedBy}
                isPinned={post.isPinned}
              />
            ))
          )}
        </div>
      </main>
    </>
  );
}
